import { Suspense } from "react";

function withSuspense(Component, fallback) {
  return function WithSuspenseWrapper(props) {
    return (
      <Suspense fallback={fallback}>
        <Component {...props} />
      </Suspense>
    );
  };
}

export default withSuspense;
